@use '../../assets/styles/variables.scss' as vars;

.button {
  display: inline-block;
  padding: 0.75rem 1.5rem;
  background-color: vars.$darkblue;
  color: vars.$white;
  font-family: inherit;
  font-size: 1rem;
  font-weight: 300;
  text-align: center;
  text-decoration: none;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease, opacity 0.3s ease;

  &:hover {
    opacity: 0.8;
  }

  &:active {
    opacity: 0.8;
  }
}
